import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useNotionContext } from '../context';
import ChevronLeft from '../icons/chevron-left';
import ChevronRight from '../icons/chevron-right';
import { CollectionCard } from './collection-card';
import { groupBlocksByDate } from './collection-view-calendar';
export function CalendarModal(_a) {
    var _b = _a.show, show = _b === void 0 ? false : _b;
    var _c = useNotionContext(), calendarMobileModalControls = _c.calendarMobileModalControls, darkMode = _c.darkMode, updateCalendarControls = _c.updateCalendarControls;
    var _d = useState([]), calendarBlocks = _d[0], setCalendarBlocks = _d[1];
    var _e = useState([]), blocks = _e[0], setBlocks = _e[1];
    var _f = useState(new Date()), currentDay = _f[0], setCurrentDay = _f[1];
    useEffect(function () {
        if (blocks.length > 0) {
            var property = blocks[0].misc.prop;
            var nBlocks = groupBlocksByDate(blocks, property);
            setCalendarBlocks(nBlocks[format(currentDay, 'yyyy-MM-dd')] || []);
        }
    }, [currentDay]);
    useEffect(function () {
        var _a = calendarMobileModalControls.date, date = _a === void 0 ? new Date() : _a, _b = calendarMobileModalControls.blocks, blocks = _b === void 0 ? [] : _b;
        setBlocks(blocks);
        setCurrentDay(date);
    }, [calendarMobileModalControls]);
    return (React.createElement("div", { className: "notion-calendar-modal ".concat(darkMode ? ' dark-mode' : '', "  ").concat(show ? 'notion-calendar-modal--open' : '') },
        React.createElement("div", { className: 'notion-calendar-modal-header' },
            React.createElement("span", null),
            React.createElement("div", { className: 'notion-calendar-header-controls' },
                React.createElement("span", { onClick: function () { return null; } },
                    React.createElement(ChevronLeft, { height: 42, width: 42, style: { transform: 'scale(.5)' }, fill: 'currentColor', onClick: function () {
                            return setCurrentDay(new Date(currentDay.getFullYear(), currentDay.getMonth(), currentDay.getDate() - 1));
                        } })),
                React.createElement("span", { className: 'current-day' }, format(currentDay, 'MMMM dd')),
                React.createElement("span", { onClick: function () { return null; } },
                    React.createElement(ChevronRight, { height: 42, width: 42, fill: 'currentColor', style: { transform: 'scale(.5)' }, onClick: function () {
                            return setCurrentDay(new Date(currentDay.getFullYear(), currentDay.getMonth(), currentDay.getDate() + 1));
                        } }))),
            React.createElement("span", { className: 'notion-calendar-modal-header-button', onClick: function () {
                    return updateCalendarControls({ date: currentDay, blocks: blocks }, false);
                } }, "Done")),
        React.createElement("div", { className: 'notion-calendar-modal-body', onClick: function () {
                updateCalendarControls({ date: currentDay, blocks: blocks }, false);
            } }, calendarBlocks.map(function (block) { return (React.createElement(CollectionCard, { collection: block.misc.collection, block: block.value, cover: block.misc.cover, coverSize: block.misc.size, coverAspect: block.misc.aspect, properties: block.misc.property, key: block.value.id })); }))));
}
//# sourceMappingURL=calendar-modal.js.map